import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: 16,
    margin: '12px 0'
  },
  header: {
    marginBottom: 16
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.grey[500],
    fontSize: 13,
    marginTop: 4
  },
  collapse: { marginTop: 16 },
  section2: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 24,
    gap: 16
  },
  fieldLabel: {
    fontWeight: 500,
    marginBottom: 8,
    color: theme.palette.text.primary
  },
  helperText: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.grey[500],
    marginTop: 6
  },
  input: {
    maxWidth: 320,
    width: '100%'
  },
  divider: {
    height: 1,
    backgroundColor: theme.palette.grey[300],
    margin: '24px 0'
  },
  toggleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  toggleText: {
    display: 'flex',
    flexDirection: 'column'
  },
  soloContainer: {
    display: 'grid',
    // gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr 1fr'
  }
}))
export default useStyles
